import { useState } from 'react'
import axios from 'axios'
import './SEOWaitlist.css'

export function SEOWaitlist() {
  const [email, setEmail] = useState('')
  const [state, setState] = useState<'idle' | 'loading' | 'done' | 'error'>('idle')

  const submit = async () => {
    if (!email.includes('@')) return
    setState('loading')
    try {
      await axios.post('/api/waitlist', { email })
      setState('done')
    } catch {
      setState('error')
    }
  }

  return (
    <div className="seo-waitlist">
      <div className="seo-waitlist-top">
        <span className="seo-waitlist-icon">🚀</span>
        <div>
          <div className="seo-waitlist-title">Premium kommt bald</div>
          <div className="seo-waitlist-sub">Vollständiges PDF · Kein Wasserzeichen · Alle Nachrichten</div>
        </div>
      </div>
      {state === 'done' ? (
        <div className="seo-waitlist-done">✓ Du wirst benachrichtigt wenn Premium live geht!</div>
      ) : (
        <>
          <div className="seo-waitlist-row">
            <input
              className="seo-waitlist-input"
              type="email"
              placeholder="deine@email.at"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submit()}
              disabled={state === 'loading'}
            />
            <button className="seo-waitlist-btn" onClick={submit} disabled={state === 'loading'}>
              {state === 'loading' ? '...' : 'Benachrichtigen'}
            </button>
          </div>
          {state === 'error' && <div className="seo-waitlist-error">Fehler — bitte nochmal versuchen.</div>}
          <div className="seo-waitlist-note">Kein Spam · Einmalige E-Mail bei Launch</div>
        </>
      )}
    </div>
  )
}
